// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CheckDaySvg[data-v-5cfea534]{width:100%;height:100%;stroke-width:2}", ""]);
// Exports
module.exports = exports;
